export enum PaymentStatus {
    SUCCESS = `SUCCESS`,
    FAILED = `FAILED`,
    CANCELLED = `CANCELLED`,
    PENDING = `PENDING`,
    NEW = `NEW`,
}